// extracted by mini-css-extract-plugin
export var infoRow = "_uc-2";
export var labelContainer = "_uc-0";
export var rightInfo = "_uc-1";